import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class ModelService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 1160
     * @datataskName sp_ws_p2_model_list
     * @param params
     * @returns promise containing list of models.
     */
    public getModels(params?: GetModelsParams): Promise<ModelItem[]> {
        return this.datatask.Post(1160, params);
    }
}

export interface GetModelsParams {
    /**
     * @default '0'
     */
    show_inactive?: '1' | '0';
}

export interface ModelItem {
    item_id: string;
    item_name: string;
    item_path: string;
    item_state: string;
    item_parms: string;
    orderby: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
    item_filtervalue: string;
}
